export default __webpack_public_path__ + "static/media/1.cdfd1197.mp4";